import { render, staticRenderFns } from "./ResumeDraftDialog.vue?vue&type=template&id=57c6bf0a&"
import script from "./ResumeDraftDialog.vue?vue&type=script&lang=js&"
export * from "./ResumeDraftDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports